import { TimerAndBalanceSection } from 'app/src/features/Landing/components/TimerAndBalanceSection'
import { getFromSessionStorage } from 'app/src/shared/helpers'
import { type ReactElement } from 'react'

export function TimerAndBalanceSectionContainer(): ReactElement {
  const campaignStorage = getFromSessionStorage('selectedCampaign') ?? '{}'
  const membershipId = JSON.parse(campaignStorage).membershipId
  return <TimerAndBalanceSection key={membershipId} />
}
